import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Model from "./Model";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const ImagesModal = ({ setViewDetail, selectedData }) => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [roomIndex, setRoomIndex] = useState(0);

const images = selectedData.rooms[roomIndex].images;

  if (!selectedData) return null;


  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + images.length) % images.length
    );
  };

  const TemplateButton = ({ isActive, ml, ...rest }) => (
    <button
      className={`inline-flex items-center px-2 pb-2 font-medium text-sm relative
      ${isActive ? "text-primary-color" : "text-gray-400"}
      ${ml ? "ml-4" : ""}
      whitespace-nowrap
      after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5
      ${isActive ? "after:bg-primary-color" : "after:bg-transparent"}
      `}
      {...rest}
    >
      {rest.children}
    </button>
  );

  return (
    <Model width="w-11/12 max-w-lg" title={selectedData.title} setOpenModel={setViewDetail}>
      <Wrapper>
        <ButtonGroup>
          {selectedData.rooms.map((room, index) => (
            <TemplateButton
              key={index}
              ml={index !== 0}
              isActive={roomIndex === index}
              onClick={() => {
                setRoomIndex(index);
                setCurrentIndex(0);
              }}
            >
              {room.name}
            </TemplateButton>
          ))}
        </ButtonGroup>

        <ImageWrapper>
          <FixedImage src={images[currentIndex]} alt="Room" />

          {images.length > 1 && (
            <>
              <NavButton onClick={prevImage} className="left-3">
                <FaChevronLeft />
              </NavButton>

              <NavButton onClick={nextImage} className="right-3">
                <FaChevronRight />
              </NavButton>
            </>
          )}
        </ImageWrapper>

        <Counter>
          <CounterBadge>
            {currentIndex + 1} / {images.length}
          </CounterBadge>
        </Counter>

      </Wrapper>
    </Model>
  );
};
const ButtonGroup = tw.div`flex items-center mt-2 overflow-x-auto whitespace-nowrap  scrollbar-hide`;
const Wrapper = tw.div`px-4`;
const ImageWrapper = tw.div`relative mt-4`;
const NavButton = tw.button`absolute top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow`;
const Counter = tw.div`mt-4 flex justify-center`;
const CounterBadge = tw.div`px-4 py-1.5 rounded-full text-sm font-semibold text-gray-700 shadow-sm`;
const FixedImage = tw.img`w-[500px] h-[300px] object-cover rounded-lg shadow-lg`;

export default ImagesModal;











  
  
  


// import React, { useState } from "react";
// import tw from "tailwind-styled-components";
// import Model from "./Model";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// const ImagesModal = ({ setViewDetail, selectedData }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   if (!selectedData?.images) return null;

//   const nextImage = () => {
//     setCurrentIndex(
//       (prev) => (prev + 1) % selectedData.images.length
//     );
//   };

//   const prevImage = () => {
//     setCurrentIndex(
//       (prev) =>
//         (prev - 1 + selectedData.images.length) %
//         selectedData.images.length
//     );
//   };

//   return (
//     <Model width={`w-11/12 max-w-lg`} title={selectedData.title} setOpenModel={setViewDetail}>
//       <Wrapper>
//         {/* <Title>{selectedData.title}</Title> */}

//         <ImageWrapper>
//             <FixedImage
//                 src={selectedData.images[currentIndex]}
//                 alt="Room"
//             />
//             <NavButton onClick={prevImage} className="left-3">
//                 <FaChevronLeft />
//             </NavButton>

//             <NavButton onClick={nextImage} className="right-3">
//                 <FaChevronRight />
//             </NavButton>
//         </ImageWrapper>

//         <Counter>
//             <CounterBadge>
//                 {currentIndex + 1} / {selectedData.images.length}
//             </CounterBadge>
//         </Counter>
//       </Wrapper>
//     </Model>
//   );
// };

// export default ImagesModal;

// const Wrapper = tw.div`px-4`;
// const Title = tw.h2`text-lg text-gray-700 font-semibold mb-4 text-center`;
// const ImageWrapper = tw.div`relative`;
// const NavButton = tw.button`absolute top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow`;
// const Counter = tw.div`mt-4 flex justify-center`;
// const CounterBadge = tw.div` px-4 py-1.5 rounded-full text-sm font-semibold text-gray-700 shadow-sm`;
// const FixedImage = tw.img`w-[500px] h-[300px] object-cover rounded-lg shadow-lg`;
// // const Counter = tw.div`text-center mt-3 text-sm font-semibold text-gray-600`;
// // const Counter = tw.div`absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/60 backdrop-blur-md text-white text-xs font-semibold px-4 py-1.5 rounded-full shadow-lg tracking-wide `;